<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.50008 9.79175C6.92508 9.79175 6.45842 10.2584 6.45842 10.8334C6.45842 11.4084 6.92508 11.8751 7.50008 11.8751C8.07508 11.8751 8.54175 11.4084 8.54175 10.8334C8.54175 10.2584 8.07508 9.79175 7.50008 9.79175ZM12.5001 9.79175C11.9251 9.79175 11.4584 10.2584 11.4584 10.8334C11.4584 11.4084 11.9251 11.8751 12.5001 11.8751C13.0751 11.8751 13.5417 11.4084 13.5417 10.8334C13.5417 10.2584 13.0751 9.79175 12.5001 9.79175ZM10.0001 1.66675C5.40008 1.66675 1.66675 5.40008 1.66675 10.0001C1.66675 14.6001 5.40008 18.3334 10.0001 18.3334C14.6001 18.3334 18.3334 14.6001 18.3334 10.0001C18.3334 5.40008 14.6001 1.66675 10.0001 1.66675ZM10.0001 16.6667C6.32508 16.6667 3.33341 13.6751 3.33341 10.0001C3.33341 9.75842 3.35008 9.51675 3.37508 9.28342C5.34175 8.40842 6.90008 6.80008 7.71675 4.80841C9.22508 6.94175 11.7084 8.33342 14.5167 8.33342C15.1667 8.33342 15.7917 8.25841 16.3917 8.11675C16.5667 8.70842 16.6667 9.34175 16.6667 10.0001C16.6667 13.6751 13.6751 16.6667 10.0001 16.6667Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
